// extracted by mini-css-extract-plugin
export var backButton = "_t-1";
export var content = "_t-d";
export var continueButton = "_t-7";
export var continueHint = "_t-8";
export var continueRow = "_t-6";
export var leftInner = "_t-0";
export var shell = "_t-e";
export var sidebarContent = "_t-5";
export var skipButton = "_t-c";
export var spacer = "_t-2";
export var spin = "_t-a";
export var spinner = "_t-9";
export var spinnerOverlay = "_t-b";
export var subtitle = "_t-4";
export var title = "_t-3";